import React, { Fragment } from "react";
import { Footerlight, PageLayout } from "../../../Constant";
import AccountContainer from "./AccountList";

const Account = () => {
    return (
        <Fragment>
            <AccountContainer mainTitle={Footerlight} title={Footerlight} parent={PageLayout} />  
        </Fragment>
    )
}
export default Account;